export const state = {
  // product: undefined,
  // products: []
  flux: {},
  fluxs: [],
  pagination:''
}
